import React from 'react';
import { Redirect } from 'react-router';

import { defaultLanguage } from '../locales/locale';

export const DefaultRoute: React.FC = () => {
  return <Redirect to={`/${defaultLanguage}/`} />;
};
